import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Erhabene Flaeche (MUI-`Paper`-Ersatz) auf `.sec-paper`-Basis. */
export const Paper = forwardRef(function Paper({ className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('sec-paper', className), ...rest });
});
